import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=84b2fd08&scoped=true"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=84b2fd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b2fd08",
  null
  
)

export default component.exports